export default "__VITE_ASSET__3a44ffc4__"